export default "<adn-report-requester obj=\"::resource.model\"></adn-report-requester>";